import { trackFacebookEvent } from './trackFacebookEvent'
import { trackMetaEvent } from './trackMetaEvent'
import { trackAlgoliaAnalytics } from './trackAlgoliaAnalytics'
import { pushToDataLayer } from './pushToDataLayer'

export const tracking = {
  trackFacebookEvent,
  trackMetaEvent,
  trackAlgoliaAnalytics,
  pushToDataLayer
}
